import { GetOpportunitiesResponse } from '../types/get-opportunities-response';

export const createLabelsCell = (
  row: GetOpportunitiesResponse
): JSX.Element => (
  <>
    <div>
      <div>{row.labels.join(' ')}</div>
    </div>
    {row.callLabel ? (
      <>
        <div>
          <span className="mr-1">Static:</span>
          {row.callLabel}
        </div>
      </>
    ) : (
      <></>
    )}
  </>
);
